import { CUSTOMER_APIS } from "@/api_framework/api_config";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback } from "react";
import toast from "react-hot-toast";
import AxiosCurlirize from "axios-curlirize";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { useAPIUtils } from "@/app/hooks/useAPIUtils";

export interface IVaccinationDobSpeciesBreedPutBody {
  dob: string;
}

export interface IVaccinationDobSpeciesBreedPutResponse {
  status: boolean;
  message: string;
  data: {
    pet_id: string;
  };
}

AxiosCurlirize(axios, () => {});
type InventoryTaxCreateAPIResponse = { status: boolean; message: string };

export const useVaccinationDobUpdateAPI = () => {
  const configuration = useConfiguration();
  const dispatch = useAppDispatch();
  const { sendCurl } = useCurlLogger();
  const { captureError } = useAPIUtils();

  const execute = useCallback(
    async (filterParams: IVaccinationDobSpeciesBreedPutBody, petId: string, userId: string) => {
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        const response: InventoryTaxCreateAPIResponse = await axios
          .put(`${CUSTOMER_APIS?.VACCINATION_DOB_BREED_SPECIES_UPDATE?.baseURL}${petId}/${userId}`, filterParams, {
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res: AxiosResponse<IVaccinationDobSpeciesBreedPutResponse>) => {
            if (res.data.status) {
              toast.success("Pet DOB has been updated");
              return { status: true, message: "" };
            } else {
              return { status: false, message: null };
            }
          })
          .catch((e: AxiosError) => {
            sendCurl(e.config["curlCommand"]);
            captureError(e);
            return { status: false, message: null };
          });
        return response;
      } catch (e: any) {
        toast.error("Server Error: " + e.message);
      }
    },
    [dispatch],
  );
  return { execute };
};
